import react, { useState } from 'react';
import Carrier from './Carrier';
import NewGraduate from './NewGraduate'

import {Switch, Route, Redirect, withRouter, NavLink} from 'react-router-dom';

const Main = (props) => {
  return (
    <>
      {/* <div class="l-main-content">
        <div class="l-section-layout"> */}
          <Carrier/>
        {/* </div>
      </div> */}
          {/* <div className="p-search-box">
            <p className="c-sentence  -black -size_28_20 -bold">募集要項を絞り込む</p>
            <div className="p-search-box__switching">
              <NavLink className="p-search-box__switching-item js-switching-item" activeClassName="-active" exact to="/recruit/entry/index.html" >
                <i className="p-search-box__switching-icon -graduation"></i>
                <div className="p-search-box__switching-text">新卒採用</div>
              </NavLink>
              <NavLink className="p-search-box__switching-item js-switching-item"  activeClassName="-active" to="/recruit/entry/carrier/">
                <i className="p-search-box__switching-icon -check_list"></i>
                <div className="p-search-box__switching-text">キャリア採用／ポテンシャル採用</div>
              </NavLink>
            </div>
            <Switch>
              <Route exact path='/recruit/entry/index.html' component={NewGraduate}/>
              <Route path='/recruit/entry/carrier/' component={Carrier}/>
              <Route path='/recruit/entry/new-graduate/' component={NewGraduate}/>
            </Switch>
          </div> */}
    </>
  );
}

export default withRouter(Main);
//export default Main;
